import addFilter from './filter/add';

export default function (state, value) {
  if (value) {
    if (value.ItemsLegend) {
      state.columns = [];
      value.ItemsLegend.forEach(i => {
        if (!i.CanVisible) return;
        state.columns.push({
          type: i.Type ? i.Type : 'text',
          name: i.FieldName,
          fixed: i.IsFixed,
          visible: i.IsVisible,
          width: i.ColumnWidth,
          label: i.Name,
          index: i.ColumnIndex,
          id: i.FieldName + i.ColumnIndex,
          data: i,
        });
      });
      state.data.ItemsLegend = value.ItemsLegend;
    } else {
      state.data.ItemsLegend = [];
    }
    if (value.CustomSettings) {
      value.CustomSettings.forEach(i => {
        switch (i.Name) {
          case 'columns':
            break;
          case 'filters':
            let filters = JSON.parse(i.Value);
            state.filters = [];
            filters.forEach(j => {
              addFilter(state, j);
            });
            break;
          default:
            if (typeof state[i.Name] !== 'undefined') state[i.Name] = JSON.parse(i.Value);
        }
      });
      state.data.CustomSettings = value.CustomSettings;
    } else {
      state.data.CustomSettings = state.data.CustomSettings ? state.data.CustomSettings : [];
    }
    if (!state.filters.length) {
      addFilter(state);
    }
    if (!state.filter) {
      state.filter = state.filters[0].id;
    }
    if (!state.default) {
      state.default = state.filter;
    }
  }
  state.loading = false;
  state.cbs.forEach(i => {
    i(state);
  });
  state.cbs = [];
}
